import { MutableRefObject, useRef, useState } from 'react'
import Styles from './CreateReviewActionConfigModal.module.scss'
import { ModalPromptProps } from '../../hooks/useActionModalPrompt'
import { CreateReviewActionConfig } from '../../stores/Workflows/Types'
import { SelectPropertyValue } from '../../api/clients/PropertyClient'
import { ReviewConfigProvider } from './ReviewConfigProvider'
import { ConfigureReview } from './ConfigureReview'
import { InviteEmails } from './InviteEmails'
import { ReviewType } from '../ReviewsWizard/types'
import { MaybeWithArticle } from './WithArticle'
import { Modal } from 'almanac-ui/Modal'

type Props = ModalPromptProps<
  Partial<CreateReviewActionConfig>,
  {
    articleId?: string
    to: SelectPropertyValue
    connectedTo?: SelectPropertyValue
    reviewType: ReviewType
    onClose: () => void
  }
>

export enum ModalState {
  CreateReview = 'CreateReview',
  InviteEmails = 'InviteEmails',
}

export interface ModalPortals {
  header: MutableRefObject<HTMLDivElement | null>
  footer: MutableRefObject<HTMLDivElement | null>
}

export const CreateReviewsActionConfigModal = ({ to, connectedTo, title, ...props }: Props) => {
  const header = useRef(null)
  const footer = useRef(null)
  const [modalState, setModalState] = useState(ModalState.CreateReview)

  return (
    <MaybeWithArticle articleId={props.articleId}>
      {(article) => (
        <ReviewConfigProvider {...props} article={article}>
          <Modal.Root size="md" onPressOutside={props.onClose}>
            <Modal.Header onClose={props.onClose}>
              <div ref={header} />
            </Modal.Header>
            <Modal.Content className={Styles.body}>
              <div className={Styles.container}>
                {modalState === ModalState.CreateReview && (
                  <ConfigureReview
                    onInviteEmails={() => setModalState(ModalState.InviteEmails)}
                    header={header}
                    footer={footer}
                    to={to}
                    article={article}
                    connectedTo={connectedTo}
                    onClose={props.onClose}
                  />
                )}
                {modalState === ModalState.InviteEmails && (
                  <InviteEmails onBack={() => setModalState(ModalState.CreateReview)} header={header} footer={footer} />
                )}
              </div>
            </Modal.Content>
            <div className={Styles.footer} ref={footer} />
          </Modal.Root>
        </ReviewConfigProvider>
      )}
    </MaybeWithArticle>
  )
}
